import * as React from "react";
import "./PlaceholderText.css";
import { HRQuestion, HRDownloadableFilePreviewResponse } from "../../messages/HR";
import "./PlaceholderDownloadableFile.css";
import { Spinner, Intent } from "@blueprintjs/core";
import { HRQuestionId } from "../../messages";
import { StatusComponent } from "../widgets/StatusComponent";
import { HRQuestionWithStatus } from "../../models/HR";

interface PlaceholderDownloadableFileProps {
    hrDownloadableFileQuestionWithStatus: HRQuestionWithStatus<HRQuestion.DownloadableFileQuestion>;
    onChange: (newVal: string | null, id: HRQuestionId) => void;
    getDownloadableFile: (hrQuestion: HRQuestion) => Promise<HRDownloadableFilePreviewResponse>;
    onTriggerEvaluateHierarchyStatus: (id: HRQuestionId) => void;
}

interface PlaceholderDownloadableFileState {
    isFetchingFile: boolean;
}

export class PlaceholderDownloadableFile extends React.Component<PlaceholderDownloadableFileProps, PlaceholderDownloadableFileState> {
    constructor(props: PlaceholderDownloadableFileProps) {
        super(props);

        this.state = {
            isFetchingFile: false
        };
    }

    async onDownloadFileClick() {
        this.setState({ isFetchingFile: true });

        this.props.onChange("Downloaded", this.props.hrDownloadableFileQuestionWithStatus.question.id);
        let downloadableFile;

        try {
            downloadableFile = await this.props.getDownloadableFile(this.props.hrDownloadableFileQuestionWithStatus.question);
        } catch (e) {
            this.props.onChange(null, this.props.hrDownloadableFileQuestionWithStatus.question.id);
            throw new Error("Couldn't download file");
        }
        if (downloadableFile.fileUrl === null) {
            return;
        }

        fetch(downloadableFile.fileUrl)
            .then(res => res.arrayBuffer())
            .then(blob => {
                const file = new Blob([(blob)], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(file);

                const link = document.createElement("a");
                link.setAttribute("href", fileURL);
                link.setAttribute("download", this.props.hrDownloadableFileQuestionWithStatus.question.questionText);
                document.body.appendChild(link);
                link.click();

                this.props.onTriggerEvaluateHierarchyStatus(this.props.hrDownloadableFileQuestionWithStatus.question.id);
                this.setState({ isFetchingFile: false });
            });
    }

    render() {
        const status = this.props.hrDownloadableFileQuestionWithStatus.status;
        return (
            <div className="PlaceholderDownloadableFile">
                <div className="PlaceholderDownloadableFile__downloadContainer">
                    <h4 dangerouslySetInnerHTML={{ __html: this.props.hrDownloadableFileQuestionWithStatus.question.questionText }} />
                    <div className="PlaceholderDownloadableFile__downloadContainer_btnStatusContainer">
                        <button
                            onClick={() => this.onDownloadFileClick()}
                            disabled={this.state.isFetchingFile === true}
                        >
                            <i className="fa fa-download" />
                        </button>
                        {this.state.isFetchingFile ?
                            <Spinner intent={Intent.PRIMARY} className={"bp3-small"} /> : null
                        }
                    </div>
                </div>
                <StatusComponent questionStatus={status}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/placeholders/PlaceholderDownloadableFile.tsx